import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { CtaBand } from '../components/ui/CtaBand';
import { FaqList } from '../components/ui/FaqList';
import { SectionHeading } from '../components/ui/SectionHeading';
import { faqs, steps } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function HowItWorks() {
  useDocumentMeta({
    title: 'How care works — Republic',
    description: 'Intake, labs, a written protocol you approve, then ongoing adjustment against real data. A clinic that shows its work.'
  });
  return <main data-id="element-371" data-mp="1ok8e93wlm4fv">
      <PageHeader eyebrow="How it works" title="A clinic that shows its work." intro="Republic runs the same sequence for every patient: intake, labs, a written protocol you approve, then ongoing adjustment against real data." data-id="element-372" data-mp="1ojgint3046pl" />

      <section className="bg-cream" data-id="element-373" data-mp="vt86qiz26ijg">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-12 md:px-8 md:pb-28" data-id="element-374" data-mp="10tvw707n2rbk">
          <ol data-id="element-375" data-mp="1rrn6nl7ym7si">
            {steps.map((step, index) => <li key={step.label} className="rule grid gap-6 py-10 lg:grid-cols-[6rem_1fr_1fr] lg:gap-12" data-id="element-376" data-mp="1rqvdeh1u4m5e" data-mpi={index}>
                <div data-id="element-377" data-mp="1ns63iyg09mqi">
                  <span className="font-serif text-4xl text-brick" data-id="element-378" data-mp="1izcx864w26cb">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <p className="mt-2 text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-379" data-mp="1dzgv6cfr4oze">
                    {step.duration}
                  </p>
                </div>
                <h2 className="font-serif text-3xl leading-tight text-ink md:text-[2.5rem]" data-id="element-380" data-mp="141sy3fuob5e2">
                  {step.title}
                </h2>
                <p className="max-w-xl text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-381" data-mp="100qwisdaah8x">
                  {step.detail}
                </p>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="bg-ink text-cream-light" data-id="element-382" data-mp="2uc5nfci16mq9">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-383" data-mp="2pgqbwr7hx2x0">
          <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-384" data-mp="38jidp9awctmx">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/230e2201-9ec3-4760-a3e6-154643c044fa.jpg" alt="A Republic clinician reviewing a patient panel" className="aspect-[3/2] w-full object-cover" data-id="element-385" data-mp="3daqoa8nyql1o" />
            <div data-id="element-386" data-mp="34gcbqduthom9">
              <SectionHeading eyebrow="Your care team" tone="cream" title="One clinician, not a queue." intro="You are assigned a clinician licensed in your state who stays with you across renewals. Messages are answered within one business day, and dose changes do not require a new visit fee." data-id="element-387" data-mp="3s818c6eo8z90" />
              <dl className="rule-light mt-10 grid gap-8 pt-8 sm:grid-cols-3" data-id="element-388" data-mp="3n73jjaz5p6yj">
                {[{
                value: '< 24 hrs',
                label: 'Median protocol turnaround'
              }, {
                value: '2,100',
                label: 'Partner draw sites'
              }, {
                value: '50',
                label: 'States licensed'
              }].map(stat => <div key={stat.label} data-id="element-389" data-mp="1zbovxnawherd">
                    <dt className="font-serif text-3xl text-cream-light" data-id="element-390" data-mp="1zani5b2i2e5y">{stat.value}</dt>
                    <dd className="mt-2 text-sm leading-relaxed text-cream/60" data-id="element-391" data-mp="2d9naasp81b6v">{stat.label}</dd>
                  </div>)}
              </dl>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-cream-light" data-id="element-392" data-mp="1kmizg73g62n6">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-393" data-mp="1gkxquxxy4ais">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-394" data-mp="1giup5gnfksy8">
            <SectionHeading eyebrow="Questions" title="Answered plainly." data-id="element-395" data-mp="1uddkx98vcy7k" />
            <FaqList items={faqs} data-id="element-396" data-mp="1pkaz5nac2t1x" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-397" data-mp="11uzwu1dc4qlo" />
    </main>;
}